<template>
  <div class="flex flex-col relative border rounded p-2 gap-2">
     <div>Channel: WhatsApp Group</div>
    <el-form-item label="WhatsApp Group ID" label-position="top">
      <el-input
        type="text"
        placeholder="e.g., 120363406300437224@g.us"
        v-model="ruleForm.config.group_id"
        clearable
      >
        <template #append>
          <i
            class="icon-pipette cursor-pointer size-4"
            @click="handleChooseGroup"
          />
        </template>
      </el-input>
    </el-form-item>
    <p class="text-xs text-muted-foreground">
      Click the
      <el-button size="mini" icon="icon-pipette" @click="handleChooseGroup" />
      button in Group ID input box to search a Whats app Group ID.
    </p>
    <button
      @click="emit('remove')"
      type="button"
      class="absolute right-2 top-2 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
    >
      <i class="icon-x h-4 w-4" />
      <span class="sr-only">Close</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "EditRecipientWhatsAppGroupItem",
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ruleForm: { ...this.value },
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.ruleForm = { ...newVal };
      },
      deep: true,
    },
  },
  methods: {
    async handleChooseGroup() {
      const groupId = await this.$loaderWindow({
        title: "Search WhatsApp Group",
        component: () => import("./WhatsAppGroupIDPicker.vue"),
        width: "600px",
        closeOnClickModal: false,
        props: {
          groupId: this.ruleForm.config.group_id,
        },
      });
      if (groupId) {
        this.ruleForm.config.group_id = groupId;
        this.$emit("input", this.ruleForm);
      }
    },
    emit(event) {
      this.$emit(event);
    },
  },
};
</script>
